import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  background-color: rgba(204, 57, 57, 0.16);

  padding: 0.7rem;

  span {
    color: #f04545;
    font-family: IBM Plex Sans;
    font-weight: 400;
  }
`;

type Props = {
  text: string;
};

function ErrorAlert({ text }: Props) {
  return (
    <Container>
      <span>{text}</span>
    </Container>
  );
}

export { ErrorAlert };
